/* ============================================================
   Variant Picker – Cascading Availability
   Dynamically disables option values that have no available
   variant when combined with the current selections.
   ============================================================ */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('variant-selects');
    if (!container) return;

    const variantsScript = container.querySelector('script[data-product-variants]');
    if (!variantsScript) return;

    const variants = JSON.parse(variantsScript.textContent);
    const fieldsets = Array.from(
      container.querySelectorAll('fieldset[id^="variant-picker-"]')
    );

    if (fieldsets.length === 0) return;

    // ---- Helpers ----

    /** Collect currently selected option values (1 per fieldset, in order). */
    function getSelectedOptions() {
      return fieldsets.map(function (fs) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    /** Find the variant that matches ALL selected options. */
    function findMatchedVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (opt, i) {
          return !opt || v['option' + (i + 1)] === opt;
        });
      }) || null;
    }

    // ---- Cascading availability ----

    /**
     * For each option at position `pos` (1-indexed), a value is available if
     * there exists at least one variant where:
     *   - All options at positions < pos match the current selection
     *   - option[pos] equals this value
     *   - variant.available === true
     *
     * Position 1 has no prior constraints, so its values are available
     * whenever ANY variant with that value is in stock (global check).
     */
    function updateAvailability() {
      const selected = getSelectedOptions();

      fieldsets.forEach(function (fieldset, idx) {
        const position = idx + 1;
        const radios = fieldset.querySelectorAll('input[type="radio"]');

        radios.forEach(function (radio) {
          const isAvailable = variants.some(function (variant) {
            if (!variant.available) return false;

            for (let p = 1; p < position; p++) {
              if (selected[p - 1] && variant['option' + p] !== selected[p - 1]) {
                return false;
              }
            }

            return variant['option' + position] === radio.value;
          });

          radio.disabled = !isAvailable;
        });
      });

      const matched = findMatchedVariant(selected);
      if (fieldsets.length === 1) {
        updatePrices();
      }
      updateTotalPrice(matched);
      updateSubmitButton(matched);
      updateHiddenInput(matched);
    }

    // ---- Per-row price update ----

    /**
     * For each radio button, compute the variant that would result from
     * selecting that value (keeping all other current selections), and
     * display its price in the row's [data-variant-price] element.
     */
    function updatePrices() {
      const selected = getSelectedOptions();

      fieldsets.forEach(function (fieldset, idx) {
        const radios = fieldset.querySelectorAll('input[type="radio"]');

        radios.forEach(function (radio) {
          const hypothetical = selected.slice();
          hypothetical[idx] = radio.value;

          const variant = findMatchedVariant(hypothetical);

          const label = fieldset.querySelector('label[for="' + radio.id + '"]');
          if (!label) return;

          const priceEl = label.querySelector('[data-variant-price]');
          if (!priceEl) return;

          if (variant) {
            priceEl.textContent = Robin.getPrice(variant.price / 100);
          } else {
            priceEl.textContent = '';
          }
        });
      });
    }

    // ---- Submit button state ----

    function updateSubmitButton(variant) {
      const btn = document.querySelector('.product-form__submit');
      if (!btn) return;

      const textEl = btn.querySelector('[data-button-text]');

      if (!variant) {
        btn.disabled = true;
        if (textEl) textEl.textContent = 'UNAVAILABLE';
      } else if (!variant.available) {
        btn.disabled = true;
        if (textEl) textEl.textContent = 'we ran out of stock';
      } else {
        btn.disabled = false;
        if (textEl) textEl.textContent = 'Add to cart';
      }
    }

    // ---- Total price label ----

    function updateTotalPrice(variant) {
      const container = document.querySelector('.variant-total-price');
      const totalEl = document.querySelector('[data-variant-total-price]');
      if (!totalEl) return;

      const hasSellingPlan =
        variant &&
        Array.isArray(variant.selling_plan_allocations) &&
        variant.selling_plan_allocations.length > 0;

      if (container) {
        container.classList.toggle('hidden', !variant || hasSellingPlan);
      }

      if (variant && !hasSellingPlan) {
        totalEl.textContent = Robin.getPrice(variant.price / 100);
      } else {
        totalEl.textContent = '';
      }
    }

    // ---- Hidden variant ID input ----

    function updateHiddenInput(variant) {
      const input = document.querySelector('input.product-variant-id[name="id"]');
      if (!input) return;

      if (variant && variant.available) {
        input.value = variant.id;
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    }

    // ---- Wire events ----

    container.addEventListener('change', function () {
      updateAvailability();
    });

    // Run once on page load for initial state
    updateAvailability();
  });
})();
